module.exports = __webpack_public_path__ + "static/media/WhatsApp.5a5c2235.png";